module.exports = __webpack_public_path__ + "static/media/10_hero_mobile.876d1cce.jpg";